import axios from 'axios'

// API基础URL
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api'

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 添加session token到请求头
    const sessionToken = localStorage.getItem('sessionToken')
    if (sessionToken) {
      config.headers['x-session-token'] = sessionToken
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const message = error.response?.data?.message || error.message || '请求失败'
    return Promise.reject(new Error(message))
  }
)

// API方法
export default {
  // 注册
  register (userData) {
    return api.post('/register', userData)
  },

  // 登录
  login (username, password) {
    return api.post('/login', { username, password })
  },

  // 登出
  logout () {
    return api.post('/logout')
  },

  // 获取所有用户
  getUsers () {
    return api.get('/users')
  },

  // 添加用户
  addUser (userData) {
    return api.post('/users', userData)
  },

  // 更新用户
  updateUser (userId, userData) {
    return api.put(`/users/${userId}`, userData)
  },

  // 审批用户
  approveUser (userId) {
    return api.post(`/users/${userId}/approve`)
  },

  // 禁用/启用用户
  toggleUserDisable (userId, isDisabled) {
    return api.post(`/users/${userId}/toggle-disable`, { is_disabled: isDisabled })
  },

  // 删除用户
  deleteUser (userId) {
    return api.delete(`/users/${userId}`)
  },

  // 检查当前用户状态
  checkUserStatus (username) {
    return api.get(`/users/me?username=${username}`)
  },

  // 健康检查
  healthCheck () {
    return api.get('/health')
  },

  // 验证session
  verifySession () {
    return api.get('/session/verify')
  },

  // 激活码管理
  getActivationCodes () {
    return api.get('/activation-codes')
  },

  generateActivationCode (data) {
    return api.post('/activation-codes', data)
  },

  updateActivationCode (codeId, data) {
    return api.put(`/activation-codes/${codeId}`, data)
  },

  deleteActivationCode (codeId) {
    return api.delete(`/activation-codes/${codeId}`)
  },

  verifyActivationCode (code, machineInfo, userId) {
    return api.post('/activation-codes/verify', { 
      code, 
      machine_info: machineInfo,
      user_id: userId 
    })
  },

  checkMachineActivationCode (machineInfo) {
    return api.post('/activation-codes/check-machine', { machine_info: machineInfo })
  }
}
